import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="poller"
export default class extends Controller {
  static values = { url: String, interval: Number }

  connect() {
    this.poll()
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  poll() {
    this.timer = setTimeout(() => {
      $.ajax({
        url: this.urlValue,
        dataType: 'script'
      })
    }, this.intervalValue || 5000)
  }
}
